import { siteData } from "@/mocks/siteData";

export default function ComparisonTable() {
  return (
    <section id="comparacao" className="py-16 md:py-24 px-4 md:px-8 bg-background-50">
      <div className="max-w-7xl mx-auto">
        <div className="flex flex-col lg:flex-row gap-10 lg:gap-16 items-center">
          <div className="lg:w-1/2 w-full">
            <div className="rounded-3xl overflow-hidden h-[300px] md:h-[420px]">
              <img
                src="https://readdy.ai/api/search-image?query=Professional%20product%20comparison%20concept%20two%20elegant%20shopping%20packages%20side%20by%20side%20on%20minimalist%20warm%20cream%20surface%20soft%20natural%20lighting%20editorial%20style%20clean%20composition%20neutral%20beige%20tones%20modern%20aesthetic%20one%20package%20slightly%20highlighted%20premium%20feel%20balanced%20symmetrical%20layout&width=800&height=600&seq=comparison-v2-img&orientation=landscape"
                alt="CSSBuy vs Outros Agentes comparação"
                className="w-full h-full object-cover"
              />
            </div>
          </div>

          <div className="lg:w-1/2 w-full">
            <span className="inline-block px-3 py-1.5 rounded-full bg-accent-100 text-accent-800 text-xs font-semibold mb-4 whitespace-nowrap">
              Análise
            </span>
            <h2 className="font-heading text-3xl md:text-4xl lg:text-5xl font-bold text-foreground-900 leading-tight">
              CSSBuy vs<br />Outros Agentes
            </h2>
            <p className="mt-5 text-foreground-600 text-sm md:text-base leading-relaxed">
              Comparamos os principais agentes de compra para ajudar você a escolher a melhor opção. Nossa análise considera taxas, tempo de envio, qualidade do suporte e experiência geral do usuário.
            </p>

            <div className="mt-8 overflow-x-auto">
              <table className="w-full text-sm">
                <thead>
                  <tr className="border-b border-background-200">
                    <th className="text-left py-3 pr-4 text-foreground-500 font-medium text-xs uppercase tracking-wider whitespace-nowrap">Agente</th>
                    <th className="text-left py-3 pr-4 text-foreground-500 font-medium text-xs uppercase tracking-wider whitespace-nowrap">Taxa</th>
                    <th className="text-left py-3 pr-4 text-foreground-500 font-medium text-xs uppercase tracking-wider whitespace-nowrap">Tempo</th>
                    <th className="text-left py-3 pr-4 text-foreground-500 font-medium text-xs uppercase tracking-wider whitespace-nowrap">Suporte</th>
                    <th className="text-right py-3 text-foreground-500 font-medium text-xs uppercase tracking-wider whitespace-nowrap">Nota</th>
                  </tr>
                </thead>
                <tbody>
                  {siteData.comparisonTable.map((row, idx) => (
                    <tr key={row.agent} className={`border-b border-background-100 ${idx === 0 ? 'bg-primary-50/50' : ''}`}>
                      <td className="py-3.5 pr-4">
                        <span className={`font-semibold whitespace-nowrap ${idx === 0 ? 'text-primary-700' : 'text-foreground-900'}`}>
                          {idx === 0 && <i className="ri-checkbox-circle-fill text-primary-500 mr-1.5"></i>}
                          {row.agent}
                        </span>
                      </td>
                      <td className="py-3.5 pr-4">
                        <span className={`inline-flex items-center gap-1 px-2 py-0.5 rounded-full text-xs font-medium whitespace-nowrap ${
                          row.taxa === 'Baixa' ? 'bg-primary-100 text-primary-700' : 'bg-secondary-100 text-secondary-700'
                        }`}>{row.taxa}</span>
                      </td>
                      <td className="py-3.5 pr-4 text-foreground-700 text-xs whitespace-nowrap">{row.tempo}</td>
                      <td className="py-3.5 pr-4 text-foreground-700 text-xs whitespace-nowrap">{row.suporte}</td>
                      <td className="py-3.5 text-right">
                        <span className={`font-bold text-sm ${idx === 0 ? 'text-primary-600' : 'text-foreground-700'}`}>{row.nota}</span>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>

            <a
              href="https://kaspreadsheet.com"
              target="_blank"
              rel="noopener nofollow"
              className="mt-6 inline-flex items-center gap-2 px-6 py-3 rounded-full bg-background-100 text-foreground-900 text-sm font-medium hover:bg-foreground-900 hover:text-background-50 transition-all whitespace-nowrap cursor-pointer"
            >
              Ver Planilha Completa
              <i className="ri-arrow-right-up-line"></i>
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}